export default "__VITE_ASSET__sHE7mGSq__"